<template>
  <div>
    <!-- 搜索 -->
    <a-form :model="searchForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="5" :xl="5">
          <a-form-item label="网站名称">
            <a-input v-model="searchForm.name" allowClear placeholder="请输入网站名称" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="5" :xl="5">
          <a-form-item label="跳转QQ">
            <a-select v-model="searchForm.is_jump_qq" allowClear show-search option-filter-prop="children" placeholder="请选择" style="width: 100%">
              <a-select-option v-for="item in ARTICLE_TYPE_IS_SHOW" :key="item.key" :value="item.key">{{
                item.value
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select v-model="searchForm.business_id" allowClear show-search option-filter-prop="children" placeholder="请选择发布平台" style="width: 100%">
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAdd">新增快商通</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 20px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <a-table row-key="id" :columns="columns" :loading="loading" :data-source="data" :pagination="pagination" style="margin-top: 20px;" @change="handleTableChange">
      <template slot="is_jump_qq" slot-scope="text">
        {{ text === '0'? '否':'是' }}
      </template>
      <template slot="introduce_js" slot-scope="text">
        {{ text ? text:'--' }}
      </template>
      <template slot="create_at" slot-scope="text, record">
        <p style="margin:0;">创建时间：{{ time(text) }}</p>
        <p style="margin:0;">更新时间：<span v-if="parseInt(record.update_at)">{{ time(record.update_at) }}</span><span v-else>--</span></p>
      </template>
      <template slot="create_number" slot-scope="text, record">
        {{ record.create_name }}({{ text }})
      </template>
      <template slot="operator" slot-scope="text, record">
        <div class="flex-c-ac">
          <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" type="link" style="margin-left: 20px" @click="del('delete', record)">删除</a-button>
        </div>
      </template>
    </a-table>

    <!-- 添加公司 -->
    <AddLink v-model="visible" :isEdit="isEdit" :List="labelList" :params="waitItem" :classifyList="classifyList" :platformList="platformList" @handleOver="getList" />
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import { searchForm, columns, form } from './business/linkRuleList'
import compuedFun from './business/index'
import { strategyCommand } from './business/tableList'
import pagination from '@/composables/pagination'
import AddLink from './components/AddLink.vue'
import moment from 'moment'
import api from '@/api/'
import store from '@/store'
export default {
  components: { AddLink },
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      times: [],
      platformList: [],
      classifyList: [],
      searchForm: { ...searchForm }
    })

    onMounted(async () => {
      await methods.getPlatform()
      methods.getArticleClassify()
      methods.getList()
    })
    const labelList = computed(() => {
      return store.state.label.data.WEBSITE?.WEBSITE_MAP_CATEGORY
    })
    const getTypeText = computed(() => {
      return (list, text) => {
        return list?.find(data => {
          return data.key === text
        })?.value
      }
    })
    const articleText = computed(() => {
      return (list, text) => {
        return list?.find(data => {
          return data.id === text
        })?.path_name
      }
    })
    const methods = {
      time(time) {
        return (time = moment(time * 1000).format('YYYY-MM-DD HH:mm:ss'))
      },
      search() {
        _this.pagination.current = 1
        this.getList()
      },

      async getList() {
        _this.loading = true
        state.searchForm.end_time = state.times[1]
        const res = await api.distributionList({
          ..._this.searchForm,
          data_status: 0,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        if (res.data !== null) {
          const { list, pagination } = res.data
          _this.data = list
          _this.pagination.total = pagination.total
          _this.loading = false
        } else {
          _this.loading = false
        }
      },

      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },

      async inputDebounce(sort, data) {
        const res = await api.updateLink(data)
        if (_this.$validate(res)) {
          _this.$message.success('操作成功~')
        }
      },
      // 刷新视图
      refreshView() {
        this.handleClear()
      },
      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },

      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      },
      async del(type, ...item) {
        strategyCommand[type].call(_this, ...item)
      },
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
      },
      // 获取文章分类
      async getArticleClassify() {
        const res = await api.listClassify()
        state.classifyList = res.data.articleType
      }
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...compuedFun(),
      ...methods,
      labelList,
      getTypeText,
      articleText
    }
  }
}
</script>
